<template>
  <div>
    <div class="headline font-weight-bold text-primary">
      Wie mogen deze gegevens inzien?
    </div>
    <p>Deze gegevens zijn te zien op de card voor iedereen. Meer informatie</p>

    <v-btn-toggle
      mandatory
      color="secondary accent-3"
      class="prive-btn-toggle"
    >
      <v-btn value="true">
        <v-icon left> fal fa-lock-alt </v-icon>
        <span class="hidden-sm-and-down">Prive</span>
      </v-btn>

      <v-btn value="false">
        <v-icon left> fal fa-users </v-icon>
        <span class="hidden-sm-and-down">Iedereen</span>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>
<script>
export default {
  props: {
    profiles: Object,
  },
  data: () => ({

  }),
};
</script>

